"use client";

import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { Reveal } from "./Reveal";
import { IMG } from "@/lib/diwline-data";
import { Shield } from "lucide-react";

/** Bannière parallaxe — Paysage avec lion doré stylisé, Gardien Royal. */
export function GardienBanner() {
  const ref = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-12%", "12%"]);

  return (
    <section
      ref={ref}
      className="relative flex min-h-[60vh] items-center justify-center overflow-hidden"
      aria-label="Gardien Royal"
    >
      <motion.div style={{ y }} className="absolute inset-0 -z-10 scale-125">
        <img
          src={`${IMG}/dame-lion.jpg`}
          alt="Lion doré stylisé, gardien royal de la savane sénégalaise"
          className="h-full w-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-royal via-transparent to-royal" />
        <div className="absolute inset-0 bg-black/35" />
      </motion.div>

      <Reveal className="relative z-10 px-6 text-center">
        <Shield className="mx-auto h-10 w-10 text-gold" aria-hidden />
        <h2 className="mt-5 font-display text-3xl md:text-5xl font-semibold text-gold-gradient animate-shimmer">
          Le Gardien Royal
        </h2>
        <p className="mt-3 font-elegant text-base md:text-lg italic text-cream/85 max-w-2xl mx-auto">
          « Paysage avec lion doré stylisé — le fauve de la savane veille sur nos champs, nos cuves
          et la prospérité de la Maison DIW&apos;LINE. »
        </p>
        <div className="mx-auto mt-6 flex items-center justify-center gap-3" aria-hidden>
          <span className="h-px w-20 bg-gold/40" />
          <svg width="12" height="12" viewBox="0 0 14 14" className="text-gold">
            <rect x="3.5" y="3.5" width="7" height="7" transform="rotate(45 7 7)" fill="currentColor" />
          </svg>
          <span className="h-px w-20 bg-gold/40" />
        </div>
      </Reveal>
    </section>
  );
}
